import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";

export const useFaqsMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemRevenue */
  const menuItemRevenue = {
    id: "revenue",
    title: "Revenue",
    url: baseRouteMakerForSuperAdmin(routes.FAQS_REVENUE),
  };
  tempMenuGroup.push(menuItemRevenue);
  /* menuItemRevenue */

  return tempMenuGroup;
};
